// Import model
import { IndividualContactCondition } from '../models/IndividualContactCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { IndividualContactIndexedFields } from '../models/IndividualContactIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { IndividualContactIndexedFieldsSerializer } from './IndividualContactIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for IndividualContactCondition - handles JSON serialization and deserialization with type validation
 */
export class IndividualContactConditionSerializer {
  /**
   * Deserializes a JSON string into a IndividualContactCondition instance
   */
  static deserialize(json: string): IndividualContactCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a IndividualContactCondition instance
   */
  static fromObject(obj: any): IndividualContactCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to IndividualContactCondition');
    }


    const instance: IndividualContactCondition = {
      fieldName: obj['fieldName'] as IndividualContactIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of IndividualContactCondition instances
   */
  static deserializeArray(json: string): IndividualContactCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a IndividualContactCondition instance to a JSON string
   */
  static serialize(instance: IndividualContactCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a IndividualContactCondition instance to a plain object
   */
  static toObject(instance: IndividualContactCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of IndividualContactCondition instances to a JSON string
   */
  static serializeArray(instances: IndividualContactCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
